export default "__VITE_ASSET__hMsUynhU__$_?nuxt_component=async&nuxt_component_name=Svgo登录d2c&nuxt_component_export=default__"